export const contentAlign = {
  left: "justify-start",
  center: "justify-center",
  right: "justify-end",
} as const;
